import { makeStyles } from '@mui/styles';

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    maxWidth: 'calc(100vw - 160px)',
  },
  appBar: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    background: '#45474e'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth
  },
  toolbar: theme.mixins.toolbar,
  toolbarImage: {
    textAlign: 'center'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3)
  },
  menuIcon: {
    minWidth: 24,
    color: '#cecece'
  },
  divider: {
    background: '#cecece'
  },
  listItemButton: {
    '&:hover': {
      backgroundColor: '#f8984e'
    },
    '&:focus': {
      backgroundColor: '#f8984e'
    }
  },
  title: {
    textAlign: 'left'
  },
  titleTypo: {
    fontSize: '36px',
    fontWeight: '100',
    lineHeight: '1.2em',
    letterSpacing: 'inherit',
    color: '#45474e'
  },
  dialogTitle: {
    fontSize: 14,
    fontWeight: '300'
  },
  '@global': {
    '.MuiDrawer-paperAnchorDockedLeft': {
      background: '#45474e'
    },
    '.MuiListItemText-primary': {
      fontSize: '1rem',
      color: '#ffffff'
    },
    'MuiListItemIcon-root': {
      minWidth: 24
    }
  }
}));

export default useStyles;
